import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/clinicians/")({
    beforeLoad: () => {
        throw redirect({ to: "/users/clinicians", replace: true });
    },
});
